function getTranslateJobType(type) {
    switch (type) {
        case 'PolicyChange':
            return 'gateway.views.job-uwissues.endorsement';
        case 'Cancellation':
            return 'gateway.views.job-uwissues.cancellation';
        case 'Renewal':
            return 'gateway.views.job-uwissues.renewal';

        default:
        case 'Submission':
            return 'gateway.views.job-uwissues.quote';
    }
}

function getTranslateWithdrawn(type, isAgent) {
    if (type === 'Renewal' && !isAgent) {
        return {
            link: 'gateway.views.quote-uwissues.Cancel',
            message: 'gateway.views.job-uwissues.this job and select a reason for the cancellation.'
        };
    }

    return {
        link: 'gateway.views.quote-uwissues.Withdraw',
        message: 'gateway.views.job-uwissues.this job if you do not wish to continue.'
    };
}

function getReferredToUnderwriterMessage(type) {
    if (type === 'Renewal') {
        return 'gateway.views.job-uwissues.You can still withdraw the renewal. If you decide not to, the underwriter will continue with the review process';
    }
    return 'gateway.views.job-uwissues.An activity will be created to inform you when the underwriter has completed the review';
}

export default function (job, isAgent) {
    var uwIssues = job ? job.underwritingIssues || [] : [];

    return {
        get uwIssues() {
            return uwIssues;
        },

        get hasUwIssues() {
            return uwIssues.length > 0;
        },

        get offerings() {
            return uwIssues[0] && uwIssues[0].offerings;
        },

        get uwIssuesAreBlocking() {
            return uwIssues.some(function (issue) {
                return issue.onOfferings && issue.onOfferings.some(function (offering) {
                    return offering.currentBlockingPoint && !['NonBlocking', 'Approved'].includes(offering.currentBlockingPoint);
                });
            }) || uwIssues.some(function (issue) {
                return !issue.onOfferings && !['NonBlocking', 'Approved'].includes(issue.currentBlockingPoint);
            });
        },

        get translateJobType() {
            if (job) return getTranslateJobType(job.type);
        },

        get jobType() {
            if (job) return job.type;
        },

        get uwIssuesHaveBeenInspectedByUW() {
            return uwIssues.some(function (issue) {
                return issue.onOfferings && issue.onOfferings.some(function (offering) {
                    return offering.hasApprovalOrRejection;
                });
            });
        },

        get translateWithdrawn() {
            if (job) return getTranslateWithdrawn(job.type, isAgent);
        },

        get getReferredToUnderwriterMessage() {
            if (job) return getReferredToUnderwriterMessage(job.type);
        },

        get isLockedToUser() {
            if (job) return job.uWLocked && job.isEditLocked;
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/util/UWUtil.js
// module id = 118
// module chunks = 0